import Authentication from "../../components/Authentication";
import { TriggerProvider } from "../../contexts/TriggerContext";
import UserContent from "./content";

export default function User() {
  return (
    <Authentication>
      <TriggerProvider>
        <UserContent />
      </TriggerProvider>
    </Authentication>
  );
}
